import { NavigationPageAction } from './micro-agent-wrapper';

export interface NREventQueueEvent {
  type: NavigationPageAction,
  options?: any;
}

declare global {
  interface Window {
    PHN_NR_EVENT_QUEUE?: NREventQueueEvent[];
  }
}

export function initEventQueue(): void {
  if (!window.PHN_NR_EVENT_QUEUE) {
    window.PHN_NR_EVENT_QUEUE = [];
  }
}

export function enqueueEvent(evt: NREventQueueEvent): void {
  window.PHN_NR_EVENT_QUEUE?.push(evt);
}

export function dequeueError(): NREventQueueEvent | undefined {
  return window.PHN_NR_EVENT_QUEUE?.shift();
}

export function getEventQueue(): NREventQueueEvent[] | undefined {
  return window.PHN_NR_EVENT_QUEUE;
}

export function clearEventQueue(): void {
  window.PHN_NR_EVENT_QUEUE = [];
}

export function eventifyEventQueue<T>(callback: (e: NREventQueueEvent[]) => T): void {
  if (!window.PHN_NR_EVENT_QUEUE) {
    return;
  }
  const queue = window.PHN_NR_EVENT_QUEUE;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (queue.push as any) = (e: NREventQueueEvent) => {
    Array.prototype.push.call(queue, e);
    callback(queue);
  };
}
